import styled from "styled-components";

export const Container = styled.div`
	display: flex;

	width: 100%;
	height: 100%;

	overflow: hidden;

	font-family: "Roboto";

	background-color: #f5f5f5;

	.header {
		font-size: 12px;
		color: #2d7bbc;
	}
`;

export const Content = styled.div`
	position: relative;

	background-color: white;
	border-radius: 5px;

	padding: 1rem 0 1rem 1rem;

	overflow: auto;

	height: 100vh;
	width: 100%;

	.buttons {
		display: flex;

		justify-content: space-around;
		align-items: center;

		width: 100%;
		height: 70px;

		background-color: white;

		bottom: 0;

		button {
			height: 45px;
			width: 120px;

			background: none;

			border-radius: 3px;
			border: none;

			cursor: pointer;

			transition: all 0.2s;
		}

		.go-back-button {
			border: 1px solid red;

			color: red;
		}

		.go-back-button:hover {
			background-color: red;
			color: white;
		}

		.send-button {
			background-color: #2d7bbc;

			color: white;
		}
	}
`;

export const DivergencesTable = styled.table`
	width: 100%;

	color: #969ba4;

	border-collapse: collapse;

	th {
		p {
			cursor: pointer;
		}

		p:hover {
			color: #626d72;
		}
	}

	th,
	td {
		padding: 1rem;
		word-wrap: break-word;
		/* text-overflow: clip; */
		text-align: center;
	}

	.text-cell {
		max-width: 10vw;

		overflow: hidden;
		/* text-overflow: ellipsis; */
	}

	.question {
		text-transform: uppercase;
	}

	.options {
		display: flex;

		gap: 10px;

		button {
			background-color: #e1e1e1;

			color: #939393;

			font-weight: bold;

			padding: 10px;

			border: none;

			cursor: pointer;

			transition: all 0.2s;
		}

		.circle-button {
			height: 35px;
			width: 35px;

			border-radius: 50%;
		}

		.circle-button:hover,
		.circle-button.active {
			background-color: rgba(54, 220, 27, 0.2);

			color: #25b20d;
		}

		.rectangle-button {
			border-radius: 3px;
		}

		.rectangle-button:hover,
		.rectangle-button.active {
			background-color: rgba(220, 27, 27, 0.2);

			color: #dc1b1b;
		}
	}

	.new-response {
		.input {
			min-width: 10rem;

			.placeholder {
				font-size: 10px;
			}
		}
	}
`;

export const TableLine = styled.tr`
	text-align: left;

	border-bottom: 1px solid #cacaca;
`;

export const DisplayDocuments = styled.iframe`
	height: 100%;
	width: 100%;
`;

export const NewResponse = styled.div`
	display: flex;

	gap: 5px;

	input {
		background-color: #e1e1e1;

		padding: 5px;

		border: none;
		border-radius: 3px;

		color: #939393;
	}

	button {
		display: flex;

		align-items: center;
		justify-content: center;

		width: 32px;
		height: 32px;

		border-radius: 50%;
		border: 1px solid red;

		transition: all 0.2s;

		cursor: pointer;

		color: red;
	}

	button:hover {
		background-color: red;

		color: white;
	}
`;
